import React, { useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import './Forces1.css';
import { auth, firestore } from '../../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { onSnapshot, doc } from "firebase/firestore";
import emailjs from '@emailjs/browser';

function Forces1 ( props ) {

    function submitFranchiseDetails ( event ) {
        event.preventDefault();
        document.querySelector( ".franchise-submit-button" ).innerHTML = "Sending...";
        let form = event.target;

        emailjs.send( "service_mjttko9", "template_wlq0g4x", {
            name: form.name.value,
            email: form.email.value,
            phone: form.phone.value,
            address: form.address.value,
            pincode: form.pincode.value,
            startFranchise: form.startFranchise.value,
            message: form.message.value
        }, "gkM2SdSnL3a-1yUti" ).then( ( response ) => {
            console.log( response.text );
            form.reset();
            document.querySelector( ".franchise-submit-button" ).innerHTML = "Submit";
        } );
    }

    useEffect( () => {
        document.title = "Get A Laundry Buddy Franchise | Premium Laundry Services";
        onAuthStateChanged( auth, async ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        props.settingDetails( {
                            name: snapshot.data().name,
                            phone: snapshot.data().mobile,
                            email: snapshot.data().email,
                            address: snapshot.data().address,
                            pincode: snapshot.data().pincode
                        } )
                    } else {
                        window.location.href = "/signup";
                    }
                } );
            }
        } );
        window.scrollTo( 0, 0 );
        document.querySelector( ".loader-container" ).style.display = "flex";
        setTimeout( () => {
            document.querySelector( ".loader-container" ).style.display = "none";
        }, 400 );
    }, [] )

    return (
        <div className='forces-page-1-container' id="forces1">
            <img className='laptop' src={require( "../../images/forces-page-banner.webp" )} alt="" />
            <img className='mobile' src={require( "../../images/forces-page-banner-mobile.webp" )} alt="" />
            <div className='forces-gallery-container'>
                <div className='forces-gallery-content'>
                    <h2>Get a Laundry Buddy Franchise</h2>
                    Laundry Buddy is the go-to laundry service in Bengaluru that has been providing top-notch laundry solutions to its customers from over 10 years. With its impeccable service and customer satisfaction, Laundry Buddy is expanding its reach by offering franchise opportunities to vendors who are willing to partner with us. As a franchisee of Laundry Buddy, you will have access to.
                    <ol>
                        <li>
                            A proven business model
                        </li>
                        <li>
                            State-of-the-art equipment
                        </li>
                        <li>
                            Ongoing support to help you succeed
                        </li>
                        <li>
                            In House Softwares
                        </li>
                        <li>
                            Vast reach of customers from our App and Website
                        </li>
                        <li>
                            And most of all, you will get the trust and loyalty of our customers which we have earned from over 10 years of service
                        </li>
                    </ol>
                    <a href="#forces1" style={{ color: "white", textDecoration: "none" }}><Button>Get In Touch</Button></a>
                </div>
                <div className='forces-gallery-image'>
                    <img src={require( "../../images/forces-page-image.webp" )} alt="" />
                </div>
            </div>
            <form onSubmit={event => submitFranchiseDetails( event )}>
                <h4>Fill the Form and our team will get to within 24 Hours</h4>
                <div className='forces-form-input-container'>
                    <div className='form-input-container'>
                        <div className='form-input-head'>
                            Name
                        </div>
                        <div className='form-input'>
                            <input type="text" placeholder='Enter Your Name' name="name" required autoFocus />
                        </div>
                    </div>
                    <div className='form-input-container'>
                        <div className='form-input-head'>
                            Email Id
                        </div>
                        <div className='form-input'>
                            <input type="email" placeholder='Enter Your Email Id' name="email" required />
                        </div>
                    </div>
                    <div className='form-input-container'>
                        <div className='form-input-head'>
                            Phone Number
                        </div>
                        <div className='form-input'>
                            <input type="tel" placeholder='Enter Your Phone Number' name="phone" minLength={10} maxLength={10} required />
                        </div>
                    </div>
                    <div className='form-input-container'>
                        <div className='form-input-head'>
                            Address
                        </div>
                        <div className='form-input'>
                            <input type="text" placeholder='Enter Your Address' name="address" required />
                        </div>
                    </div>
                    <div className='form-input-container'>
                        <div className='form-input-head'>
                            Pincode
                        </div>
                        <div className='form-input'>
                            <input type="tel" placeholder='Enter Your Pincode' name="pincode" minLength={6} maxLength={6} required />
                        </div>
                    </div>
                    <div className='form-input-container'>
                        <div className='form-input-head'>
                            How Soon You Want To Start Franchise
                        </div>
                        <div className='form-input'>
                            <select name="startFranchise">
                                <option value="">Select Option</option>
                                <option value="As Soon As Possible">As Soon As Possible</option>
                                <option value="This Week">This Week</option>
                                <option value="This Month">This Month</option>
                                <option value="Not Sure">Not Sure</option>
                            </select>
                        </div>
                    </div>
                </div>
                <textarea placeholder='Enter Your Message Here' name='message'></textarea>
                <Button type="submit" className='franchise-submit-button'>Submit</Button>
            </form>
        </div>
    )
}

export default Forces1